import { Component, Input } from "@angular/core";

export type HudArcGradient = "vpip" | "pfr" | "threeBet";

const HUD_ARC_GRADIENTS: Record<
  HudArcGradient,
  { start: string; end: string }
> = {
  vpip: { start: "#00E5FF", end: "#2979FF" },
  pfr: { start: "#FF4181", end: "#FF88D8" },
  threeBet: { start: "#00FF87", end: "#15E8E9" },
};

@Component({
  selector: "app-hud-stat-arc",
  templateUrl: "./hud-stat-arc.component.html",
  styleUrls: ["./hud-stat-arc.component.scss"],
})
export class HudStatArcComponent {
  @Input() label = "";
  @Input() value: number | string = 0;
  @Input() highlighted = false;
  @Input() gradient: HudArcGradient = "vpip";

  readonly arcRadius = 38;
  readonly arcSweepDegrees = 270;
  readonly arcLength = (this.arcSweepDegrees / 360) * 2 * Math.PI * this.arcRadius;
  readonly gradientId = `hud-arc-gradient-${Math.random().toString(36).slice(2, 9)}`;

  get gradientStops() {
    return HUD_ARC_GRADIENTS[this.gradient];
  }

  get displayValue(): string {
    if (this.label === "Total Hands") {
      return String(this.value ?? 0);
    }
    return `${Math.round(Number(this.value) || 0)}%`;
  }

  get filledLength(): number {
    const percent = Math.max(0, Math.min(100, Number(this.value) || 0));
    return (percent / 100) * this.arcLength;
  }

  get dashArray(): string {
    return `${this.arcLength} ${this.arcLength}`;
  }

  get dashOffset(): number {
    const filled = this.filledLength;
    if (filled <= 0) {
      return this.arcLength;
    }
    return this.arcLength - filled;
  }
}
